import { privateApi } from '@/config/axios.config';
import {
  UnifiedContact,
  ContactsFilter,
  ContactsListResponse,
  ContactType,
  CreateContactPayload,
  UpdateContactPayload,
} from '../types/contacts-types';

const BASE_URL = '/contacts';

export const contactsApi = {
  getAll: async (filters?: ContactsFilter): Promise<ContactsListResponse> => {
    const params = new URLSearchParams();
    if (filters?.search) params.append('search', filters.search);
    if (filters?.types?.length) {
      filters.types.forEach((t) => params.append('types', t));
    }
    if (filters?.status) params.append('status', filters.status);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.limit) params.append('limit', filters.limit.toString());
    if (filters?.sortBy) params.append('sortBy', filters.sortBy);
    if (filters?.sortOrder) params.append('sortOrder', filters.sortOrder);

    const response = await privateApi.get(`${BASE_URL}?${params.toString()}`);
    return response.data?.data ?? response.data;
  },

  getById: async (type: ContactType, id: string): Promise<UnifiedContact> => {
    const response = await privateApi.get(`${BASE_URL}/${type}/${id}`);
    return response.data?.data ?? response.data;
  },

  getStats: async (): Promise<Record<string, number>> => {
    const response = await privateApi.get(`${BASE_URL}/stats`);
    return response.data?.data ?? response.data;
  },

  create: async (payload: CreateContactPayload): Promise<UnifiedContact> => {
    const response = await privateApi.post(BASE_URL, payload);
    return response.data?.data ?? response.data;
  },

  update: async (
    type: ContactType,
    id: string,
    payload: UpdateContactPayload
  ): Promise<UnifiedContact> => {
    const response = await privateApi.put(`${BASE_URL}/${type}/${id}`, payload);
    return response.data?.data ?? response.data;
  },

  delete: async (
    type: ContactType,
    id: string
  ): Promise<{ success: boolean; message: string }> => {
    const response = await privateApi.delete(`${BASE_URL}/${type}/${id}`);
    return response.data?.data ?? response.data;
  },
};
